import React from 'react';
import { packItems } from '../data/content';
export function WhatsInside() {
  return <section id="inside" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-185" data-mp="yvr11dwvo5qs">
      <div className="mx-auto max-w-4xl" data-id="element-186" data-mp="yto8on8960iw">
        <h2 className="text-center font-display text-[1.9rem] font-extrabold uppercase leading-tight text-ink sm:text-[2.6rem]" data-id="element-187" data-mp="kx13xya2662f">
          <span aria-hidden="true" data-id="element-188" data-mp="ptrigh67stlq">📦 </span>What&apos;s Inside the Football
          Ready Pack?
        </h2>

        <ul className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-189" data-mp="b4brp16ooo61">
          {packItems.map(item => <li key={item.title} className="rounded-2xl border border-ink/5 bg-chalk px-6 py-8 text-center" data-id="element-190" data-mp="fyzk3b4t62pw">
              <span className="text-2xl leading-none" aria-hidden="true" data-id="element-191" data-mp="75w8779t9xxd">
                {item.emoji}
              </span>
              <h3 className="mt-4 font-display text-xl font-bold uppercase leading-tight text-ink" data-id="element-192" data-mp="3odq9bgxwn9qi">
                {item.title}
              </h3>
              <p className="mt-2 text-xs leading-relaxed text-ink/55" data-id="element-193" data-mp="3cteece3fnf4t">
                {item.text}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}